import React, { useEffect, useState } from "react";
import "./AppLoadingBanner.css";

const LOADING_MESSAGES = [
  { title: <>On prépare la route.<br />Vous donnez la direction.</>, message: "Préparation de votre espace de travail…" },
  { title: <>Votre flotte vous attend.<br />On vous ouvre la voie.</>, message: "Chargement de votre tableau de bord…" },
  { title: <>Chaque trajet compte.<br />La journée commence ici.</>, message: "Préparation de votre vue d’ensemble…" },
  { title: <>On rassemble les pièces.<br />Vous voyez l’ensemble.</>, message: "Chargement de vos données…" },
  { title: <>Gardez le cap.<br />On prépare la suite.</>, message: "Mise en place de votre espace de travail…" },
  { title: <>Une vue claire.<br />Pour aller de l’avant.</>, message: "Chargement de votre activité…" },
  { title: <>Du premier départ au dernier arrêt.<br />Vous gardez la main.</>, message: "Préparation de votre tableau de bord…" },
  { title: <>Vos opérations prennent forme.<br />À vous de les guider.</>, message: "Chargement de votre espace de gestion…" },
  { title: <>Tout commence par<br />une bonne vue d’ensemble.</>, message: "Préparation de vos informations…" },
  { title: <>La journée se met en route.<br />Vous prenez les commandes.</>, message: "Encore un instant avant le départ…" },
];

export default function AppLoadingBanner({
  action = null,
  title,
  message,
}) {
  const [messageIndex, setMessageIndex] = useState(() => Math.floor(Math.random() * LOADING_MESSAGES.length));
  const hasCustomCopy = title !== undefined || message !== undefined;

  useEffect(() => {
    if (hasCustomCopy) return;

    const intervalId = window.setInterval(() => {
      setMessageIndex((index) => (index + 1) % LOADING_MESSAGES.length);
    }, 6000);

    return () => window.clearInterval(intervalId);
  }, [hasCustomCopy]);

  const loadingCopy = LOADING_MESSAGES[messageIndex];
  const displayedTitle = title !== undefined
    ? title
    : hasCustomCopy ? <>On prépare le terrain.<br />Vous prenez le volant.</> : loadingCopy.title;
  const displayedMessage = message !== undefined
    ? message
    : hasCustomCopy ? "Préparation de votre espace de travail…" : loadingCopy.message;

  return (
    <section className="app-loading-banner" aria-busy="true">
      <div className="app-loading-banner__panel">
        <div className="app-loading-banner__copy" role="status">
          <p className="app-loading-banner__eyebrow">
            <span aria-hidden="true" />
            Chargement
          </p>
          <h2>{displayedTitle}</h2>
          <p className="app-loading-banner__message">{displayedMessage}</p>
        </div>
        <svg className="app-loading-banner__route" viewBox="0 0 360 92" aria-hidden="true">
          <path d="M 8 81 H 352" />
          <circle cx="8" cy="81" r="4" />
          <circle cx="240" cy="81" r="4" />
          <circle cx="352" cy="81" r="4" />
          <g className="app-loading-banner__truck">
            <path d="M 90 69 H 168 V 75 H 90 Z" />
            <rect x="90" y="43" width="76" height="26" />
            <path d="M 169 47 H 175 L 183 52 L 190 61 V 75 H 169 Z" />
            <path d="M 172 52 H 181 L 187 61 H 172 Z" />
            <path d="M 172 64 H 187 M 173 67 H 177 M 187 68 H 190" />
            {[101, 114, 127, 179].map((x) => (
              <g key={x} transform={`translate(${x} 75)`}>
                <g className="app-loading-banner__wheel">
                  <circle r="5" />
                  <path className="app-loading-banner__spokes" d="M 0 0 V -3.5 M 0 0 L 3 1.75 M 0 0 L -3 1.75" />
                </g>
              </g>
            ))}
          </g>
        </svg>
        <div className="app-loading-banner__progress" role="progressbar" aria-label="Chargement en cours">
          <span />
        </div>
        {action ? <div className="app-loading-banner__action">{action}</div> : null}
      </div>
    </section>
  );
}
